export default "__VITE_ASSET__t5p$y_KM__"